import { createRouter, createWebHistory } from 'vue-router';
import store from './store/store';

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('./pages/Login.vue')
    },
    {
        path: '/',
        name: 'Shop',
        component: () => import('./pages/Shop.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/cart',
        redirect: '/'
    },
    {
        path: '/order-confirmation',
        name: 'OrderConfirmation',
        component: () => import('./pages/OrderConfirmation.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/unfulfilled',
        name: 'UnfulfilledOrders',
        component: () => import('./pages/UnfulfilledOrders.vue'),
        meta: { requiresAuth: true }
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth && !store.getters['auth/isAuthenticated']) {
        next({ name: 'Login' });
    } else {
        next();
    }
});

export default router;
